import { throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class BankTenantService {
  private baseApiUrl: string;

  constructor(private configurationService: ConfigurationService, private httpClient: HttpClient) {
    this.baseApiUrl = this.configurationService.BaseApiUrl;
  }



  getAllUnions(isMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `union?isMaintenance=${isMaintenance}`).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  createBankTenant(bankTenantDetails: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'mutlitenantuser', bankTenantDetails).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  updateBankTenant(bankTenantDetails: any): Observable<any> {
    return this.httpClient.put(this.baseApiUrl + 'mutlitenantuser', bankTenantDetails).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getFiltered(filter: string, pageIndex: number, pageSize: number,
    sortColumn: string, sortAscending: boolean, isMaintenance: boolean = true, forBank: boolean): Observable<any> {

    const params = {
      filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance, forBank
    };

    return this.httpClient.post(this.baseApiUrl + 'mutlitenantuser/filter', params).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getBankTenantById(id: number, forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `mutlitenantuser/${id}?isMaintenance=${forMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

   getBankTenantByUnionId(unionId: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `union/unionsaccos/${unionId}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
}
